if (typeof Handlebars !== "undefined") {
  Handlebars.registerHelper("increment", function (value, options) {
    return parseInt(value) + 1;
  });

  Handlebars.registerHelper("for", function (from, to, incr, block) {
    var accum = "";
    for (var i = from; i < to; i += incr) accum += block.fn(i);
    return accum;
  });

  Handlebars.registerHelper("ifEquals", function (arg1, arg2, options) {
    return arg1 == arg2 ? options.fn(this) : options.inverse(this);
  });

  Handlebars.registerHelper("ifNotEquals", function (arg1, arg2, options) {
    return arg1 != arg2 ? options.fn(this) : options.inverse(this);
  });

  Handlebars.registerHelper("getSliderRange", function (arg1) {
    return arg1.length - 1;
  });

  Handlebars.registerHelper("baloon", function (textArg) {
    function replace(text, counter = 1) {
      const posStart = text.search("\\[\\[");
      const posEnd = text.search("\\]\\]");
      if (posStart == -1 || posEnd == -1) return text;

      function extractContent(s) {
        var span = document.createElement("span");
        span.innerHTML = s;
        return span.textContent || span.innerText;
      }
      const baloonTextAndLabel = text.slice(posStart + 2, posEnd + 2).replace("]]", "");

      const [baloonText, baloonLabel] = extractContent(baloonTextAndLabel).split(":");
      if (!baloonLabel) return baloonText;

      const baloonStr = `<span class="baloon" data-id="${counter}" data-label="${baloonLabel}">${baloonText}</span>`;
      const res = text.slice(0, posStart) + baloonStr + text.slice(posEnd + 2);
      counter++;
      return replace(res, counter);
    }

    return replace(textArg);
  });
}
